export class UploadFailure extends Error {
	readonly status?: number;
	readonly code?: string;
	readonly retryable?: boolean;
	readonly retryAfterMs?: number;

	constructor(
		message: string,
		details: {
			status?: number;
			code?: string;
			retryable?: boolean;
			retryAfterMs?: number;
		} = {}
	) {
		super(message);
		this.name = "UploadFailure";
		this.status = details.status;
		this.code = details.code;
		this.retryable = details.retryable;
		this.retryAfterMs = details.retryAfterMs;
	}
}
